import { makeStyles } from '@material-ui/core/styles';

export const useStyles = makeStyles(theme => ({
  processBulkOrderContainer: {
    padding: theme.spacing(47, 0, 38.5),
    flex: 1,
    display: 'flex',
    flexDirection: 'row',
    justifyContent: 'center',
  },
  processBulkOrderContent: {
    maxWidth: theme.spacing(408),
  },
  uploadedFileStatusContainer: {
    height: theme.spacing(110),
    border: '1px solid #ABAFB3',
    borderRadius: 20,
    padding: theme.spacing(15, 20, 18, 28.5),
  },
  uploadedFileTitleWrapper: {
    overflowY: 'auto',
    overflowX: 'hidden',
    maxHeight: theme.spacing(80),
  },
  uploadedFileTitle: {
    lineHeight: '40px',
    overflowWrap: 'break-word',
  },
  cancelOrderBtn: {
    padding: 0,
    color: '#F66A6A',
    '&:hover': {
      backgroundColor: 'unset',
    },
  },
  processOrderBtn: {
    textTransform: 'uppercase',
  },
}));
